import { render, staticRenderFns } from "./Linked.vue?vue&type=template&id=956bf532&scoped=true&"
import script from "./Linked.vue?vue&type=script&lang=js&"
export * from "./Linked.vue?vue&type=script&lang=js&"
import style0 from "./Linked.vue?vue&type=style&index=0&id=956bf532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956bf532",
  null
  
)

export default component.exports